import { render, staticRenderFns } from "./ExpensesByGroup.vue?vue&type=template&id=8dd35af0&"
import script from "./ExpensesByGroup.vue?vue&type=script&lang=js&"
export * from "./ExpensesByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports